import type { ReactNode } from "react";

export interface BentoItemProps {
  baseColSpan: number;
  baseRowSpan: number;
  children: ReactNode;
  enabled?: boolean;
  id: string;
}

export const BentoItem = ({ children }: BentoItemProps) => children;
